module.exports = __webpack_public_path__ + "img/avatar-01.a92ed095.png";